import React, { useEffect, useState } from 'react'
import ConsolidatedReportPrinting from '../../components/ConsolidatedReportPrinting'
import api from '../../services/api'

const CompetitionConsolidatedReportPrinting: React.FC<any> = ({
  competitionId,
  competitionTitle,
  childToParent,
}) => {
  const [reports, setReports] = useState<any[] | null>(null)

  useEffect(() => {
    api
      .get('/api/event_results/consolidated-report-by-competition', {
        params: { competitionId },
      })
      .then((res) => setReports(res.data))
  }, [competitionId])

  if (!reports) return null

  return (
    <ConsolidatedReportPrinting
      title={competitionTitle}
      preloadedReports={reports}
      childToParent={childToParent}
    />
  )
}

export default CompetitionConsolidatedReportPrinting
